"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModeSegmentTests = void 0;
var toggle_up_1 = require("./toggle-up");
var toggle_down_1 = require("./toggle-down");
var toggle_from_blank_1 = require("./toggle-from-blank");
var utils_1 = require("../../support/utils");
var ModeSegmentTests = /** @class */ (function (_super) {
    __extends(ModeSegmentTests, _super);
    function ModeSegmentTests(utils) {
        var _this = _super.call(this, utils) || this;
        _this.up = function () { return (0, toggle_up_1.toggleModeUp)(utils); };
        _this.down = function () { return (0, toggle_down_1.toggleModeDown)(utils); };
        _this.fromBlank = function () { return (0, toggle_from_blank_1.toggleModeFromBlank)(utils); };
        return _this;
    }
    return ModeSegmentTests;
}(utils_1.TestSuite));
exports.ModeSegmentTests = ModeSegmentTests;
